/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Kind_ScentingInputs */

const vi_stocktake_kind_scenting = /** @type {(inputs: Stocktake_Kind_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy hương`)
};

/**

* @param {Stocktake_Kind_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_kind_scenting = /** @type {((inputs?: Stocktake_Kind_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Kind_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_kind_scenting(inputs)
});